(function() {

        var elem = document.querySelectorAll('.testimonial-products .main-carousel');
        var arrowShape = 'M21.8,49.36a1.51,1.51,0,0,1,.36-.54L38.82,32.16a1.67,1.67,0,1,1,2.36,2.35L27.36,48.33H76.67a1.67,1.67,0,0,1,0,3.34H27.36L41.18,65.49a1.67,1.67,0,0,1,0,2.36,1.69,1.69,0,0,1-2.36,0L22.16,51.18h0a1.62,1.62,0,0,1-.35-.54,1.64,1.64,0,0,1,0-1.28Z';
        elem.forEach( elem => {
                new Flickity( elem, {
                       
                        cellAlign: 'center',
                        autoPlay: true,
                        contain: false,
                        wrapAround: true,
                        pageDots:true,
                        adaptiveHeight: false,
                        arrowShape:arrowShape,
                        imagesLoaded: true
                });
        });

}());